import { render, staticRenderFns } from "./orderIndex.vue?vue&type=template&id=14ea6453&"
import script from "./orderIndex.vue?vue&type=script&lang=js&"
export * from "./orderIndex.vue?vue&type=script&lang=js&"
import style0 from "./orderIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports